import { Command } from 'cmdk'
import {
  Text,
  CustomerLogo,
  GreyGrey80,
  Primary13Regular
} from '@sequencehq/core-components'
import { getLogoSrc } from 'Customer/utils/logo'
import { IconSlot } from '../components/IconSlot'
import type { CustomerResult } from '../useGlobalSearchResults'

type CustomerResultsProps = {
  customers: CustomerResult[]
  isActive: boolean
  onNavigate: (path: string) => void
}

export const CustomerResults = ({
  customers,
  isActive,
  onNavigate
}: CustomerResultsProps) => {
  if (!isActive || customers.length === 0) {
    return null
  }

  return (
    <Command.Group heading="Customers">
      {customers.map(customer => (
        <Command.Item
          key={customer.id}
          value={`customer-${customer.id}`}
          onSelect={() => onNavigate(`/customers/${customer.id}`)}
          data-testid="global-search.customer-result"
        >
          <IconSlot>
            <CustomerLogo
              size={24}
              fallbackSize={16}
              src={
                customer.domain
                  ? getLogoSrc({ domain: customer.domain })
                  : undefined
              }
            />
          </IconSlot>
          <Text {...Primary13Regular} color={GreyGrey80}>
            {customer.legalName}
          </Text>
        </Command.Item>
      ))}
    </Command.Group>
  )
}
